import AmbGames from './AmbGames'

export default AmbGames
